'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var reactUtils = require('@chakra-ui/react-utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className", "children", "spacing", "width", "w", "rowWidth", "rowW"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var _createContext = reactUtils.createContext({
    name: 'RowContext',
    errorMessage: 'useRowContext: `context` is undefined. Seems you forgot to wrap `<Col />` components in `<Row />`.'
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  RowProvider = _createContext2[0],
  useRowContext = _createContext2[1];
/**
 * Row
 *
 * A copy of the `Row` element of common CSS frameworks, used with `Col`.
 */
var Row = react.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    _props$spacing = props.spacing,
    spacingProp = _props$spacing === void 0 ? 6 : _props$spacing,
    widthProp = props.width,
    wProp = props.w,
    rowWidthProp = props.rowWidth,
    rowWProp = props.rowW,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var styles = {
    display: 'flex',
    ml: utils.mapResponsive(spacingProp, function (s) {
      if (typeof s === 'number') {
        return -Math.abs(s);
      }
      return "-".concat(s);
    }),
    flexWrap: 'wrap'
  };
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: utils.cx("chakra-row", className),
    __css: _objectSpread(_objectSpread({}, styles), {}, {
      width: rowWidthProp,
      w: rowWProp
    })
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement(RowProvider, {
    value: {
      spacing: spacingProp,
      width: widthProp || wProp
    }
  }, children));
});
Row.displayName = 'Row';
exports.Row = Row;
exports.RowProvider = RowProvider;
exports.useRowContext = useRowContext;